/**
 * The retired `/me/planned` (TMMAPP-0145): an old link replaces itself with the page it meant.
 * `?view=cashflow` is Cash flow, carrying its `scope` and horizon `h`; anything else is Recurring,
 * carrying `view` (calendar or list), `status`, `account` and `month`. Every other param is dropped.
 */
import { Navigate, useSearchParams } from 'react-router-dom';
import { CASH_FLOW_PATH, RECURRING_PATH } from './plannedRoutes';

const RECURRING_PARAMS = ['view', 'status', 'account', 'month'] as const;
const CASH_FLOW_PARAMS = ['scope', 'h'] as const;

function carry(from: URLSearchParams, keys: readonly string[]): string {
  const next = new URLSearchParams();
  for (const key of keys) {
    const value = from.get(key);
    if (value !== null) next.set(key, value);
  }
  const query = next.toString();
  return query === '' ? '' : `?${query}`;
}

export function LegacyPlannedRedirect() {
  const [params] = useSearchParams();
  const to =
    params.get('view') === 'cashflow'
      ? `${CASH_FLOW_PATH}${carry(params, CASH_FLOW_PARAMS)}`
      : `${RECURRING_PATH}${carry(params, RECURRING_PARAMS)}`;
  return <Navigate to={to} replace />;
}
